import CircularProgress from '@mui/material/CircularProgress';

const LoadingSpinner = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-10 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center justify-center gap-4">
        <CircularProgress size='3rem' sx={{ color: '#635bff' }} />
        <div className="text-lg font-medium text-gray-600">Data Loading...</div>
      </div>
    </div>
  );
};

export default LoadingSpinner;